import React from 'react';
import { useFela } from '../..';
import { WithTheme } from '../../Theme/utils/ThemeTypes';
import { LoadingAnimationProps } from './LoadingAnimationProps';

const offset = 187;
const duration = '1.4s';

const spinner = (renderer: any) => {
  const rotation = () => ({
    '0%': { transform: 'rotate(0deg)' },
    '100%': { transform: 'rotate(270deg)' },
  });
  const rotationAnimation = renderer.renderKeyframe(rotation);
  return {
    animation: `${rotationAnimation} ${duration} linear infinite`,
    left: 0,
    right: 0,
    top: 0,
    transform: 'scale(1)',
    bottom: 0,
    margin: 'auto',
  };
};

const path =
  (renderer: any) =>
  ({ theme }: WithTheme) => {
    const dash = () => ({
      '0%': { strokeDashoffset: offset },
      '50%': {
        strokeDashoffset: offset / 5,
        transform: 'rotate(135deg)',
      },
      '100%': {
        strokeDashoffset: offset,
        transform: 'rotate(450deg)',
      },
    });
    const dashAnimation = renderer.renderKeyframe(dash);
    return {
      strokeDasharray: offset,
      strokeDashoffset: 0,
      transformOrigin: 'center',
      animation: `${dashAnimation} ${duration} ease-in-out infinite`,
      stroke: theme.palette.color2.hex,
    };
  };

const Spinner = ({
  size,
  title,
  description,
  dmId = 'dm-spinner',
  id,
}: LoadingAnimationProps): React.ReactElement => {
  const { css, renderer } = useFela();

  // Accessibility attributes
  const TITLE_ID = `${id || dmId}Title`; // todo: dmId should be removed, as soon as id prop is required (myt-7757)
  const DESC_ID = description ? ` ${id || dmId}Desc` : ''; // todo: dmId should be removed, as soon as id prop is required (myt-7757)
  const ARIA_LABELLEDBY = `${TITLE_ID}${DESC_ID}`;

  return (
    <svg
      className={css(spinner(renderer))}
      width={`${size}px`}
      height={`${size}px`}
      viewBox="0 0 66 66"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={ARIA_LABELLEDBY}
      role="img">
      <title id={TITLE_ID}>{title}</title>
      {description && <desc id={DESC_ID}>{description}</desc>}
      <circle
        className={css(path(renderer))}
        fill="none"
        strokeWidth="6"
        strokeLinecap="round"
        cx="33"
        cy="33"
        r="30"
      />
    </svg>
  );
};

export default Spinner;
